import { Component, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute, PRIMARY_OUTLET } from '@angular/router';
import { BreakpointObserver, Breakpoints, MediaMatcher } from '@angular/cdk/layout';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { AppService } from '../services/app.service';
import { AuthService } from 'projects/Shared-Lib/services/auth.service';

enum DisplayStatus {
  Open, Close
}

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  @ViewChild('MainWrapper') mainWrapper: ElementRef;
  @ViewChild('UserIcon') UserIcon: ElementRef;  //host listener document click outside this element
  @ViewChild(BreadcrumbComponent) breadcrumbRef: BreadcrumbComponent; //reference to the breadcrumb

  title = 'CSS Auth Portal';
  ParentPath = 'Dashboard';
  Controller: string = 'User';

  currentUser: any;
  matcher: MediaQueryList;
  auth: AuthService;
  controlItems: any;

  // load control
  loading = false;
  subscription: Subscription;

  // display-status control
  _sidebarStatus: DisplayStatus;
  _usericonStatus: DisplayStatus;

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches)
    );

  constructor(
    private breakpointObserver: BreakpointObserver,
    private mediaMatcher: MediaMatcher,
    private appService: AppService,
    private router: Router,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private http: HttpClient) {
    this.subscription = appService.loadingObservable.subscribe(loading => this.loading = Boolean(loading));
    this.matcher = this.mediaMatcher.matchMedia('(min-width: 768px)');
    this.matcher.addListener(this.MainListener);
    this.auth = new AuthService(http, null, toastr);
    this.auth.getData(this.Controller + '/Menus', null,
      (data) => {
        // success
        appService.SetMenu(data);
      }, (data) => {
        // failure
        console.log(data);
      });
  }

  ngOnInit() {
    if (this.matcher.matches) {
      this._sidebarStatus = DisplayStatus.Open;
    } else {
      this._sidebarStatus = DisplayStatus.Close;
    }

    this._usericonStatus = DisplayStatus.Close;

    if (!localStorage.getItem('user')) {
      this.toastr.warning('Missing login user information , redirect to login page', 'Missing some information', {
        positionClass: 'toast-top'
      });
    } else {
      this.currentUser = JSON.parse(localStorage.getItem('user'));
    }
  }

  ngAfterViewInit(): void {
    // View has been initialized!
  }

  // when children component loading finish , trigger this.
  ngAfterViewChecked(): void {
    /** this part can't move to ngAfterViewInit , cuz there's another child component */
    if (this.controlItems) {
      let mainContainer = document.querySelector('#main-container');
      this.controlItems.forEach(setting => {
        let elements = mainContainer.querySelectorAll(setting.ItemName);

        if (elements.length > 0) {
          for (let index = 0; index < elements.length; index++) {
            const element = elements[index];
            switch (element.tagName.toLowerCase()) {
              case 'a':
                element.classList.add('disabled');
                break;
              default:
                element.setAttribute('disabled', 'disabled');
                break;
            }
          }
        }
      });
    }
  }

  ngOnDestroy() {
    this.matcher.removeListener(this.MainListener);
    this.subscription.unsubscribe();
  }

  onChangeParentPath(Path: string) {
    this.ParentPath = Path;

    // handle menu click event , toggle icon and class
    let main = document.querySelector('#main-wrapper');
    let icon = document.querySelector('.ti-close');

    if (!this.matcher.matches) {
      // handset
      if (this._sidebarStatus === DisplayStatus.Close) {
        main.className = 'mini-sidebar show-sidebar';
        // toggle menu icon to close
        icon.className = 'ti-close';

        this._sidebarStatus = DisplayStatus.Open;
      } else {
        main.className = 'mini-sidevar';
        // toggle menu close to menu
        icon.className = 'ti-close ti-menu';

        this._sidebarStatus = DisplayStatus.Close;
      }
    }
  }

  // handle - sidebar , user-icon-dropdown-menu display status when width change
  MainListener = (event) => {
    let main = document.querySelector('#main-wrapper');
    let icon = document.querySelector('.ti-close');
    let navbarSupportedContent = document.querySelector('#navbarSupportedContent');

    if (event.matches) {
      // match width min-width: 768px
      main.setAttribute('data-sidebartype', 'full');
      this._sidebarStatus = DisplayStatus.Open;
      main.className = "";
    }
    else {
      // not match width min-width: 768px
      main.setAttribute('data-sidebartype', 'mini-sidebar');
      // set memu close
      this._sidebarStatus = DisplayStatus.Close;
      main.className = 'mini-sidevar';
      // toggle menu close to menu
      icon.className = 'ti-close ti-menu';
    }

    // when change size , remove navbarSupportedContent children class show
    let currentShowItems = navbarSupportedContent.querySelectorAll('.show');
    if (currentShowItems.length > 0) {
      for (let index = 0; index < currentShowItems.length; index++) {
        const element: Element = currentShowItems[index];
        element.classList.remove('show');
      }
    }

    this._usericonStatus = DisplayStatus.Close;
    navbarSupportedContent.classList.remove('show');
  }

  MenuHandle() {
    let main = document.querySelector('#main-wrapper');
    let icon = document.querySelector('.ti-close');

    if (this.matcher.matches) {
      //full screen
      if (this._sidebarStatus === DisplayStatus.Open) {
        main.className = "mini-sidebar";
      }
      else {
        main.className = "";
      }
    }
    else {
      //handset
      if (this._sidebarStatus === DisplayStatus.Close) {
        main.className = "mini-sidebar show-sidebar";
        //toggle menu icon to close
        icon.className = 'ti-close';
      }
      else {
        main.className = "mini-sidevar";
        //toggle menu close to menu
        icon.className = 'ti-close ti-menu';
      }
    }

    this.toggleMenu();
  }

  //control - normal mode - dropdown menu display status
  UserHandle() {
    //let navbarSupportedContent = document.querySelector('#navbarSupportedContent');
    let li_UserIcon = document.querySelector('#li-user');

    if (li_UserIcon.classList.contains('show')) {
      li_UserIcon.classList.remove('show');
      //child div tag
      li_UserIcon.querySelector('div').classList.remove('show');
    }
    else {
      li_UserIcon.classList.add('show');
      //child div tag
      li_UserIcon.querySelector('div').classList.add('show');
    }

    if (this.matcher.matches) {
      //full screen
      this.toggleUserMenu();
    }

  }

  //control - handset mode - icon display status
  MiniUserHandle() {
    let navbarSupportedContent = document.querySelector('#navbarSupportedContent');

    if (navbarSupportedContent.classList.contains('show')) {
      navbarSupportedContent.classList.remove('show');
      //child div tag
      let elements = navbarSupportedContent.querySelectorAll('.show')
      for (let index = 0; index < elements.length; index++) {
        const element = elements[index];
        element.classList.remove('show');
      }
    }
    else {
      navbarSupportedContent.classList.add('show');
    }
  }

  toggleUserMenu() {
    this._usericonStatus = this._usericonStatus === DisplayStatus.Open ? DisplayStatus.Close : DisplayStatus.Open;
  }

  toggleMenu() {
    this._sidebarStatus = this._sidebarStatus === DisplayStatus.Open ? DisplayStatus.Close : DisplayStatus.Open;
  }

  Logout() {
    this.auth.logout();
  }

  MyProfile() {
    this.router.navigate(['Home/MyProfile']);
  }

  MainContainerActive(event) {
    //route
    let root = this.route.root;
    let resource = this.GetActivedRouteData(root);

    if (resource !== '') {
      //get user resource
      this.auth.getData(`${this.Controller}/Permission/${resource}`, null, (data) => {
        this.appService.SetResourcePermission(resource, data);
        //2021-08-23 GSSPortl Update: Disable all controls first then trun on by exsiting action. (Now disabled resource actions won't be queried)
        if (typeof (event.CanCreate) !== 'undefined')
          event.CanCreate = false;
        if (typeof (event.CanUpdate) !== 'undefined')
          event.CanUpdate = false;
        if (typeof (event.CanDelete) !== 'undefined')
          event.CanDelete = false;
        //set controls
        for (const item of data) {
          switch (item.ActionName) {
            case "Search":
              break;
            case "Create":
              if (typeof (event.CanCreate) !== 'undefined') {
                event.CanCreate = true;
              }
              break;
            case "Update":
              if (typeof (event.CanUpdate) !== 'undefined') {
                event.CanUpdate = true;
              }
              break;
            case "Delete":
              if (typeof (event.CanDelete) !== 'undefined') {
                event.CanDelete = true;
              }
              break;
            default:
              break;
          }
        }

      }, (data) => {

      });
    }

  }

  @HostListener('document:click', ['$event']) clickout(event) {
    // Click outside of the menu was detected
    if (!this.UserIcon.nativeElement.contains(event.target)) {
      let li_UserIcon = document.querySelector('#li-user');

      if (li_UserIcon.classList.contains('show')) {
        li_UserIcon.classList.remove('show');
        //child div tag
        li_UserIcon.querySelector('div').classList.remove('show');
        this._usericonStatus = DisplayStatus.Close;
      }

      if (this.matcher.matches && this._usericonStatus === DisplayStatus.Open) {
        this.UserHandle();
      }
    }
  }

  GetActivedRouteData(route: ActivatedRoute) {
    let children: ActivatedRoute[] = route.children;
    if (children.length === 0) {
      return '';
    }

    for (let child of children) {
      //verify primary route
      if (child.outlet !== PRIMARY_OUTLET) {
        continue;
      }
      if (child.snapshot) {
        if (!child.snapshot.data.hasOwnProperty('resource')) {
          return this.GetActivedRouteData(child);
        }
        else {
          return child.snapshot.data['resource'];
        }
      } else {
        return '';
      }
    }
  }

}


